import React, { useRef } from 'react';
import { Box, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import InputMask from 'react-input-mask';

import { useStores } from '../../hooks/use-stores';

import { loc } from '../../lib/loc';
import { ProfileLoc } from '../../loc/profile';

import PreloadButton from '../../interface/PreloadButton';

const EditContactData = observer(() => {
    const { ProfileDataStore: store } = useStores();
    const { phone } = store.profile || {};
    const { editLoader, editPhone } = store || {};

    const phoneRef = useRef();

    const handle = e => {
        e.preventDefault();
        editPhone(phoneRef.current.value.match(new RegExp(/[0-9]/g)).join(''));
    };

    return (
        <form onSubmit={handle}>
            <Box display="flex" flexDirection="column">
                <Box mb={2}>
                    <Typography variant="h6">{loc(ProfileLoc.changePhone)}</Typography>
                </Box>
                <InputMask
                    ref={phoneRef}
                    style={{ width: '100%' }}
                    className="login-form__input"
                    placeholder={loc(ProfileLoc.newPhone)}
                    mask="+7(999) 999-99-99"
                    maskChar="_"
                    required
                    defaultValue={phone}
                />
                <Box>
                    {' '}
                    <PreloadButton isLoad={editLoader}>{loc(ProfileLoc.sendButton)}</PreloadButton>
                </Box>
            </Box>
        </form>
    );
});

export default EditContactData;
